/* ============================================================
   VM OVERLAY MENU — Toggle
   assets/vm-overlay-menu.js
   ============================================================ */

(function () {
  'use strict';

  var overlay  = document.getElementById('vm-menu-overlay');
  var closeBtn = document.getElementById('vm-menu-close');

  if (!overlay) return;

  function openMenu() {
    // Cierra el drawer del tema Savor si está abierto
    var savorDetails = document.getElementById('Details-menu-drawer-container');
    if (savorDetails && savorDetails.open) {
      savorDetails.open = false;
    }
    overlay.style.display = 'flex';
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!overlay.classList.contains('is-open')) {
        overlay.style.display = 'none';
      }
    }, 250);
  }

  /* Botón hamburguesa del tema Savor:
     <summary class="header__icon header__icon--menu header__icon--summary">
     dentro de <details id="Details-menu-drawer-container"> */
  var HAMBURGER_SELECTORS = [
    'summary.header__icon--menu',
    'summary.header__icon--summary',
    '.header__icon--menu'
  ].join(', ');

  var triggers = document.querySelectorAll(HAMBURGER_SELECTORS);

  triggers.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openMenu();
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeMenu);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeMenu();
    }
  });

  var items = overlay.querySelectorAll('.vm-menu__item');
  items.forEach(function (item) {
    item.addEventListener('click', closeMenu);
  });

})();